/** Hundreds of rows per order, and every structural write invalidates it anyway. */
export const LIST_STALE_TIME_MS = 5 * 60_000;

/** A thread the reader is looking at; its writes patch the cache directly. */
export const CONVERSATION_STALE_TIME_MS = 5 * 60_000;

/**
 * Long enough that opening the features dropdown and then the toggle modal
 * right after reuses the same response instead of firing a second request.
 */
export const FEATURES_STALE_TIME_MS = 30_000;

/** Installation-wide reference data; an order's worth of edits never touches it. */
export const CATALOGUE_STALE_TIME_MS = 24 * 60 * 60_000;

/** The mutations patch the cache from their responses, so writes are the freshness. */
export const ANNOTATIONS_STALE_TIME_MS = Infinity;

/**
 * Organisation writes invalidate it; the per-organisation order counts in
 * `profile` move with order status, which nothing invalidates.
 */
export const PARTNER_ORGANISATIONS_STALE_TIME_MS = 30 * 60_000;

/**
 * Organisation writes invalidate it, but every signup and guest session adds a
 * row that nothing invalidates, and admins act on fresh signups.
 */
export const CUSTOMER_ORGANISATIONS_STALE_TIME_MS = 5 * 60_000;

/**
 * Admin-edited settings change a few times a year, and nothing on the client invalidates them.
 * Each open tab polls on this interval.
 */
export const PLATFORM_CONFIG_STALE_TIME_MS = 5 * 60_000;

/** A maker's QA and completed-order counts move with order status, which nothing invalidates. */
export const PARTNER_ORGANISATION_PROFILE_STALE_TIME_MS = 5 * 60_000;

/** A customer's invoice totals and order counts move with its orders, which nothing invalidates. */
export const CUSTOMER_ORGANISATION_PROFILE_STALE_TIME_MS = 5 * 60_000;

/** Admin accounts change a few times a year, and the user create, edit and archive writes invalidate it. */
export const USERS_STALE_TIME_MS = 24 * 60 * 60_000;

/** Owner changes set it from the response; only another admin's change goes unseen. */
export const ORDER_OWNERS_STALE_TIME_MS = 5 * 60_000;

/** Edited only from the organisation page, whose writes invalidate it; another admin's edit shows on focus. */
export const PARTNER_ORGANISATION_DETAIL_STALE_TIME_MS = 5 * 60_000;

/** Edited only from the organisation page, whose writes invalidate it; another admin's edit shows on focus. */
export const CUSTOMER_ORGANISATION_DETAIL_STALE_TIME_MS = 5 * 60_000;

/** An organisation never moves between the partner and customer tables. */
export const ORGANISATION_KIND_STALE_TIME_MS = Infinity;
